const ComboBoxStateChangeType = {
  InputChange: "__input_change__",
  ItemClick: "__item_click__",
  ToggleButtonClick: "__togglebutton_click__",
} as const;

Object.freeze(ComboBoxStateChangeType);

export default ComboBoxStateChangeType;
